import { render, staticRenderFns } from "./Galaxy.vue?vue&type=template&id=6f2f8018&scoped=true"
import script from "./Galaxy.vue?vue&type=script&lang=js"
export * from "./Galaxy.vue?vue&type=script&lang=js"
import style0 from "./Galaxy.vue?vue&type=style&index=0&id=6f2f8018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2f8018",
  null
  
)

export default component.exports